import React, {useState} from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import './App.css'; // Import your CSS file

import Schedule from "./schedule";
import Games from "./games";
import ScoreBoardTable from "./scoreboardtable";
import About from "./about";
import Contact from "./contactus";
import Login from "./login";

export default function PublicGrid() {
    const [displayPage, setDisplayPage] = useState("schedule");
    
    // Helper function to get button class names
    const getButtonClass = (currentPage, isGameButton = false) => {
        const baseClass = isGameButton ? 'btn-game' : 'btn-standard';
        return displayPage === currentPage ? `${baseClass} active` : baseClass;
    };

    const renderContent = () => {
        switch (displayPage) {
            case 'schedule':
                return <Schedule />;
            case 'games':
                return <Games />;
            case 'scoreboard':
                return <ScoreBoardTable />;
            case 'about':
                return <About />;
            case 'contactus':
                return <Contact />;
            case 'login':
                return <Login />;
            default:
                return <Schedule />;
        }
    };

    return (
        <div style={{ flexGrow: 1 }}>
            <Grid container spacing={3}>
                {/* Header */}
                <Grid item xs={12}>
                    <Paper className="header-footer-style">
                        <Typography component={'span'}>
                            <h1>High Score Challenge!</h1>
                        </Typography>
                    </Paper>
                </Grid>
                
                {/* Main Navigation */}
                <Grid item xs={12}>
                    <Paper className="header-footer-style">
                        <Grid container direction={"row"} justifyContent={"center"} alignItems={"center"}>
                            <Grid item xs="auto">
                                <Typography>
                                    <button 
                                        className={getButtonClass('schedule')}
                                        onClick={() => setDisplayPage("schedule")}
                                    >
                                        <h4>Schedule</h4>
                                    </button>
                                </Typography>
                            </Grid>
                            <Grid item xs="auto">
                                <Typography>
                                    <button 
                                        className={getButtonClass('games', true)}
                                        onClick={() => setDisplayPage("games")}
                                    >
                                        <h4>Games</h4>
                                    </button>
                                </Typography>
                            </Grid>
                            <Grid item xs="auto">
                                <Typography>
                                    <button 
                                        className={getButtonClass('scoreboard')}
                                        onClick={() => setDisplayPage("scoreboard")}
                                    >
                                        <h4>Scoreboard</h4>
                                    </button>
                                </Typography>
                            </Grid>
                        </Grid>
                    </Paper>
                </Grid>
                
                {/* Main Content Area */}
                <Grid item xs={12}>
                    <Grid>
                        <Grid item xs={12}>
                            <Paper className="main-style">
                                <Typography component={'span'}>
                                    <div className="fade-in">
                                        {renderContent()}
                                    </div>
                                </Typography>
                            </Paper>
                        </Grid>
                    </Grid>
                </Grid>
                
                {/* Footer Navigation */}
                <Grid item xs={12}>
                    <Paper className="header-footer-style">
                        <Grid container  direction="row" justifyContent="center" alignItems="center">
                            <Grid item xs="auto">
                                <Typography>
                                    <button 
                                        className={getButtonClass('about', true)}
                                        onClick={() => setDisplayPage("about")}
                                    >
                                        <h4>About</h4>
                                    </button>
                                </Typography>
                            </Grid>
                            <Grid item xs="auto">
                                <Typography>
                                    <button 
                                        className={getButtonClass('contactus')}
                                        onClick={() => setDisplayPage("contactus")}
                                    >
                                        <h4>Contact Us</h4>
                                    </button>
                                </Typography>
                            </Grid>
                            <Grid item xs="auto">
                                <Typography>
                                    <button 
                                        className={getButtonClass('login')}
                                        onClick={() => setDisplayPage("login")}
                                    >
                                        <h4>Login</h4>
                                    </button>
                                </Typography>
                            </Grid>
                        </Grid>
                    </Paper>
                </Grid>
            </Grid> 
        </div>
    );
}

